import {Component, computed, input} from '@angular/core';
import {TranslocoDirective} from "@jsverse/transloco";
import {NgOptimizedImage} from "@angular/common";
import {LoyaltyLevel, PillLoyaltyComponent, Size} from "shared-lib";
import {LoyaltyLevelAggregation, loyaltyLevelOrder} from '../../../services/models/onboarding-data';

@Component({
  selector: 'app-fifth-page',
  imports: [
    TranslocoDirective,
    NgOptimizedImage,
    PillLoyaltyComponent
  ],
  templateUrl: './fifth-page.component.html',
  styleUrl: './fifth-page.component.scss'
})
export class FifthPageComponent {
  loyaltyLevelAggregations = input.required<LoyaltyLevelAggregation[]>();
  sortedLoyaltyLevels = computed(() =>
    this.loyaltyLevelAggregations()
      .filter((loyaltyLevel) => loyaltyLevel.level !== LoyaltyLevel.STRANGER)
      .sort((a, b) => loyaltyLevelOrder[a.level] - loyaltyLevelOrder[b.level])
  );

  averageLoyalties = {
    [LoyaltyLevel.DEVOTED]: 8,
    [LoyaltyLevel.LOYAL]: 6,
    [LoyaltyLevel.FREQUENT]: 4,
    [LoyaltyLevel.CASUAL]: 1,
    [LoyaltyLevel.STRANGER]: 0,
  }
  protected Size = Size;

  constructor() {
  }

}
